// extracted by mini-css-extract-plugin
export var boxItems = "_7h-1";
export var boxItemsLg = "_7h-2";
export var button = "_7h-7";
export var buttonHoverless = "_7h-9";
export var buttonLg = "_7h-8";
export var filterGroupBox = "_7h-0";
export var icon = "_7h-3";
export var iconSecondary = "_7h-6";
export var iconWrapper = "_7h-4";
export var iconWrapperLg = "_7h-5";
export var truncatedLabel = "_7h-a";